module.exports = __webpack_public_path__ + "img/base_activites_plongee.491db858.svg";